import React from 'react';

const Pay = () => {
    return (
        <div>
            <h1>processing</h1>
        </div>
    );
};

export default Pay;